import { Box, Stack } from '@upright/ui/common/generic/components/layout';
import { InfoTooltip } from '@upright/ui/common/generic/components/tooltip';
import { Text } from '@upright/ui/common/generic/components/typography';
import { SectionTitle } from './section-styles';

/** An attribute section's title with its (i) guidance tooltip (`ATTRIBUTE_GUIDANCE`, PLT-7430). */
export function SectionTitleWithGuidance({ title, guidance }: { title: string; guidance: string }) {
  return (
    <Stack row align="center" gap="xs">
      <SectionTitle>{title}</SectionTitle>
      <InfoTooltip size="small" text={guidance} />
    </Stack>
  );
}

/**
 * The hint under a section whose attributes break a rule that switches them off, where it says
 * (`getAttributeWarnings`). A hint rather than a field error: the product still saves, the
 * attributes just don't count until the rule is met.
 */
export function SectionWarning({ warning }: { warning: string | undefined }) {
  if (!warning) return null;
  // The section's own gap is `xs`; with this it is the `sm` the field rhythm puts between a control and its hint.
  return (
    <Box marginBlockStart="xs">
      <Text size="sm" color="gray-600">
        {warning}
      </Text>
    </Box>
  );
}
